import { createApi } from '@core/fetch'

export default {
  flowPacketDashboard: createApi(
    '/p/wedding/index.php/admin/APIADCenter/flowPacketDashboard'
  ),
  buy: createApi.post('/p/wedding/index.php/admin/APIADCenterFlowPacket/pay'),
  flowPacketPrice: createApi(
    '/p/wedding/index.php/admin/APIADCenter/flowPacketPrice'
  ),
  flowPacketList: createApi(
    '/p/wedding/index.php/admin/APIADCenter/flowPacketList'
  ),
  actionRecord: createApi(
    '/p/wedding/index.php/admin/APIADCenterWidePlan/actionRecord'
  ),
  flowPacketSortList: createApi(
    '/p/wedding/index.php/admin/APIADCenter/flowPacketSortList'
  ),
  flowPacketSort: createApi.post(
    '/p/wedding/index.php/admin/APIADCenter/flowPacketSort'
  ),
  getPacketInfo: createApi('/p/wedding/index.php/admin/APICpmFlowPacket'),
  activatePacket: createApi.post(
    '/p/wedding/index.php/admin/APICpmFlowPacket/activate'
  ),
  ydtActivate: createApi.post(
    '/p/wedding/index.php/admin/APICpmFlowPacket/flowPacketPhotoActivate'
  ),
  changeConsumeType: createApi.post(
    '/hms/dsp/appApi/core/plan/changeConsumeType'
  )
}
